(function() {
  'use strict';
  
  class AutoDiscountMilestone {
    constructor() {
      this.milestone = document.querySelector('.wt-offer-milestone');
      if (!this.milestone) return;
      
      this.progressFill = this.milestone.querySelector('.wt-progress-bar__fill');
      this.messageText = this.milestone.querySelector('.wt-offer-milestone__text');
      this.tiers = this.milestone.querySelectorAll('.wt-offer-milestone__tier');
      this.loadingEl = this.milestone.querySelector('.wt-milestone-loading');
      
      this.config = {
        tier1: parseFloat(this.milestone.dataset.tier1),
        tier2: parseFloat(this.milestone.dataset.tier2),
        tier3: parseFloat(this.milestone.dataset.tier3),
        tier1Discount: parseFloat(this.milestone.dataset.tier1Discount),
        tier2Discount: parseFloat(this.milestone.dataset.tier2Discount),
        tier3Discount: parseFloat(this.milestone.dataset.tier3Discount),
        tier1Code: this.milestone.dataset.tier1Code,
        tier2Code: this.milestone.dataset.tier2Code,
        tier3Code: this.milestone.dataset.tier3Code,
        currentTier: parseInt(this.milestone.dataset.currentTier),
        type: this.milestone.dataset.milestoneType,
        upsellId: parseInt(this.milestone.dataset.upsellId)
      };
      
      this.init();
    }
    
    init() {
      this.attachEventListeners();
      // Apply discount on load if eligible
      this.checkAndApplyDiscount();
    }
    
    attachEventListeners() {
      const self = this;
      
      // Listen for quantity changes
      document.addEventListener('change', function(e) {
        if (e.target.classList.contains('quantity__input')) {
          self.handleQuantityChange();
        }
      });
      
      // Listen for cart updates
      if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe !== 'undefined') {
        subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
          self.updateMilestone();
        });
      }
      
      document.addEventListener('cart:updated', function() {
        self.updateMilestone();
      });
    }
    
    handleQuantityChange() {
      this.showLoading();
      const self = this;
      setTimeout(function() {
        self.updateMilestone();
      }, 500);
    }
    
    showLoading() {
      if (this.loadingEl) this.loadingEl.style.display = 'block';
    }
    
    hideLoading() {
      if (this.loadingEl) this.loadingEl.style.display = 'none';
    }
    
    updateMilestone() {
      const self = this;
      fetch('/cart.js')
        .then(function(response) { return response.json(); })
        .then(function(cart) {
          const cartValue = self.calculateCartValue(cart);
          const tierInfo = self.getTierInfo(cartValue);
          
          self.updateProgress(cartValue, tierInfo);
          self.updateMessage(cartValue, tierInfo);
          self.updateTierStatus(cartValue);
          
          // Auto-apply discount if tier changed
          if (tierInfo.tier !== self.config.currentTier) {
            self.config.currentTier = tierInfo.tier;
            self.applyDiscount(tierInfo);
          }
          
          self.hideLoading();
        })
        .catch(function(error) {
          console.error('Error updating milestone:', error);
          self.hideLoading();
        });
    }
    
    checkAndApplyDiscount() {
      if (this.config.currentTier > 0) {
        const self = this;
        fetch('/cart.js')
          .then(function(response) { return response.json(); })
          .then(function(cart) {
            const cartValue = self.calculateCartValue(cart);
            const tierInfo = self.getTierInfo(cartValue);
            self.applyDiscount(tierInfo);
          });
      }
    }
    
    applyDiscount(tierInfo) {
  if (tierInfo.tier === 0) {
    this.removeDiscount();
    return;
  }

  const discountCode = this.getDiscountCode(tierInfo.tier);
  if (!discountCode) return;

  const self = this;

  // Apply discount via Shopify AJAX
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify({
      attributes: {
        "discount_code": discountCode
      }
    })
  })
  .then(() => fetch('/cart.js'))
  .then(res => res.json())
  .then(cart => {

    console.log("Applied Discount:", discountCode);

    // Notify drawer to refresh UI
    document.dispatchEvent(new CustomEvent('cart:updated'));

    if (typeof PUB_SUB_EVENTS !== 'undefined') {
      publish(PUB_SUB_EVENTS.cartUpdate, { source: 'milestone-discount' });
    }
  })
  .catch(err => console.error("Error applying discount:", err));
}

    removeDiscount() {
  fetch('/cart/update.js', {
    method: 'POST',
    headers: {"Content-Type": "application/json"},
    body: JSON.stringify({
      attributes: {
        "discount_code": ""
      }
    })
  });
}

    
    getDiscountCode(tier) {
      switch(tier) {
        case 1: return this.config.tier1Code;
        case 2: return this.config.tier2Code;
        case 3: return this.config.tier3Code;
        default: return null;
      }
    }
    
    showDiscountApplied(cart) {
      let totalDiscount = 0;
      if (cart.cart_level_discount_applications) {
        cart.cart_level_discount_applications.forEach(function(discount) {
          totalDiscount += discount.total_allocated_amount;
        });
      }
      
      if (totalDiscount > 0) {
        const badge = this.milestone.querySelector('.wt-discount-badge');
        const appliedDiv = this.milestone.querySelector('.wt-discount-applied');
        
        if (badge) badge.style.display = 'flex';
        if (appliedDiv) {
          appliedDiv.style.display = 'flex';
          const text = appliedDiv.querySelector('.wt-discount-applied__text');
          if (text && typeof Shopify !== 'undefined') {
            text.textContent = "You're saving " + Shopify.formatMoney(totalDiscount) + "!";
          }
        }
      }
    }
    
    // calculateCartValue(cart) {
    //   const self = this;
    //   if (this.config.type === 'price') {
    //     let total = 0;
    //     cart.items.forEach(function(item) {
    //       if (item.product_id !== self.config.upsellId) {
    //         total += item.original_line_price;
    //       }
    //     });
    //     return total / 100;
    //   } else {
    //     let count = 0;
    //     cart.items.forEach(function(item) {
    //       if (item.product_id !== self.config.upsellId) {
    //         count += item.quantity;
    //       }
    //     });
    //     return count;
    //   }
    // }
//     calculateCartValue(cart) {
//   const self = this;
//   const samplePackVariantId = 44489101050038;
  
//   if (this.config.type === 'price') {
//     let total = 0;
//     cart.items.forEach(function(item) {
//       if (item.product_id !== self.config.upsellId && item.id !== samplePackVariantId) {
//         total += item.original_line_price;
//       }
//     });
//     return total / 100;
//   } else {
//     let count = 0;
//     cart.items.forEach(function(item) {
//       if (item.product_id !== self.config.upsellId && item.id !== samplePackVariantId) {
//         count += item.quantity;
//       }
//     });
//     return count;
//   }
// }
calculateCartValue(cart) {
  const self = this;
  const samplePackVariantId = 44489101050038;

  if (this.config.type === 'price') {
    let total = 0;

    cart.items.forEach(function(item) {
      if (item.product_id !== self.config.upsellId && item.id !== samplePackVariantId) {
        total += item.original_line_price;
      }
    });

    return total / 100;

  } else {
    // ✅ Quantity-based milestone (FIXED)
    let count = 0;

    cart.items.forEach(function(item) {
      if (item.product_id !== self.config.upsellId && item.id !== samplePackVariantId) {

        let packSize = 1;
        const title = (item.variant_title || '').toLowerCase();

        // Case 1: Pack of 1 / 2 / 3
        const numberMatch = title.match(/\d+/);
        if (numberMatch) {
          packSize = parseInt(numberMatch[0]);
        }

        // Case 2: Hair Health Gummy
        else if (title.includes('starter')) {
          packSize = 1;
        }
        else if (title.includes('progress')) {
          packSize = 2;
        }
        else if (title.includes('transform')) {
          packSize = 3;
        }

        count += item.quantity * packSize;
      }
    });

    return count;
  }
}
    getTierInfo(cartValue) {
      if (cartValue >= this.config.tier3) {
        return { tier: 3, discount: this.config.tier3Discount, remaining: 0 };
      } else if (cartValue >= this.config.tier2) {
        return { 
          tier: 2, 
          discount: this.config.tier2Discount, 
          nextDiscount: this.config.tier3Discount,
          remaining: this.config.tier3 - cartValue 
        };
      } else if (cartValue >= this.config.tier1) {
        return { 
          tier: 1, 
          discount: this.config.tier1Discount,
          nextDiscount: this.config.tier2Discount,
          remaining: this.config.tier2 - cartValue 
        };
      } else {
        return { 
          tier: 0, 
          discount: 0,
          nextDiscount: this.config.tier1Discount,
          remaining: this.config.tier1 - cartValue 
        };
      }
    }
    
    updateProgress(cartValue, tierInfo) {
      let percentage = 5;
      
      if (cartValue < this.config.tier1) {
        percentage = Math.max(5, (cartValue / this.config.tier1) * 33.33);
      } else if (cartValue < this.config.tier2) {
        const range = this.config.tier2 - this.config.tier1;
        const progress = (cartValue - this.config.tier1) / range;
        percentage = 33.33 + (progress * 33.33);
      } else if (cartValue < this.config.tier3) {
        const range = this.config.tier3 - this.config.tier2;
        const progress = (cartValue - this.config.tier2) / range;
        percentage = 66.66 + (progress * 33.34);
      } else {
        percentage = 100;
      }
      
      this.progressFill.style.width = percentage + '%';
    }
    
    updateMessage(cartValue, tierInfo) {
      const msgAttr = 'data-message-' + (tierInfo.tier === 0 ? 'below-tier1' : 'tier' + tierInfo.tier);
      let template = this.messageText.getAttribute(msgAttr) || '';
      
      template = template.replace('{amount}', Math.ceil(tierInfo.remaining));
      template = template.replace('{discount}', tierInfo.discount);
      template = template.replace('{next_discount}', tierInfo.nextDiscount || '');
      
      this.messageText.textContent = template;
    }
    
    updateTierStatus(cartValue) {
      const self = this;
      this.tiers.forEach(function(tier, index) {
        const threshold = [self.config.tier1, self.config.tier2, self.config.tier3][index];
        if (cartValue >= threshold) {
          tier.classList.add('active');
        } else {
          tier.classList.remove('active');
        }
      });
    }
  }
  
  // Initialize
  // if (document.readyState === 'loading') {
  //   document.addEventListener('DOMContentLoaded', function() {
  //     new AutoDiscountMilestone();
  //   });
  // } else {
  //   new AutoDiscountMilestone();
  // }
  if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', function() {
    window.autoMilestone = new AutoDiscountMilestone();
  });
} else {
  window.autoMilestone = new AutoDiscountMilestone();
}
})();

document.addEventListener("input", function (e) {
  if (!e.target.classList.contains("quantity__input")) return;

  const wrapper = e.target.closest(".cart-notification-product");
  if (!wrapper) return;

  const priceBox = wrapper.querySelector(".cart__item_price");
  if (!priceBox) return;

  const qty = parseInt(e.target.value);
  if (qty < 1) return;

  // original prices from DOM or Shopify attributes
  const lineOriginalPriceText = priceBox.getAttribute("data-line-price");
  let unitPrice = priceBox.getAttribute("data-unit-price");

  if (!unitPrice) {
    // fallback: extract from existing DOM
    const priceEl = priceBox.querySelector(".price, .old-price, .new-price");
    if (!priceEl) return;

    const priceText = priceEl.textContent.replace(/[^\d]/g, '');
    unitPrice = parseInt(priceText);
  } else {
    unitPrice = parseInt(unitPrice);
  }

  const originalLine = unitPrice * qty;

  // discount logic
  let discountPercent = 0;
   if (qty === 1) discountPercent = 15;
  if (qty === 2) discountPercent = 18;
  if (qty >= 3) discountPercent = 25;

  // If no discount → show original only
  if (discountPercent === 0) {
    priceBox.innerHTML = `
      <span class="price">₹${originalLine.toLocaleString("en-IN")}</span>
    `;
    return;
  }

  const discountAmount = (unitPrice * discountPercent) / 100;
  const discountedUnit = unitPrice - discountAmount;
  const discountedLine = discountedUnit * qty;
  const savings = originalLine - discountedLine;

  // Update HTML
  priceBox.innerHTML = `
    <div class="cart-saving-label">
      <span class="tag-icon">🏷</span>
      Buy ${qty} Get ${discountPercent}% off – ${savings.toLocaleString("en-IN")}
    </div>

    <div class="cart-price-row">
      <s class="old-price">₹${originalLine.toLocaleString("en-IN")}</s>
      <span class="new-price">₹${discountedLine.toLocaleString("en-IN")}</span>
    </div>
  `;
});


// (function() {
//   const originalFetch = window.fetch;

//   window.fetch = function() {
//     const url = arguments[0];

//     return originalFetch.apply(this, arguments).then(response => {
//       if (typeof url === 'string' && url.includes('/cart/add')) {

//         // Fetch updated cart
//         fetch('/cart.js')
//           .then(res => res.json())
//           .then(cart => {
//             if (cart.item_count > 0) {
//               const wrapper = document.getElementById('milestoneWrapper');
//               if (wrapper) wrapper.classList.remove('hidden-milestone');
//             }
//           });
//       }

//       return response;
//     });
//   };
// })();


// Free Shipping Bar Update Handler
(function() {
  function updateFreeShippingBar() {
    fetch('/cart.js')
      .then(response => response.json())
      .then(cart => {
        const samplePackVariantId = 44489101050038;
        
        // Calculate filtered cart total (excluding sample pack)
        let filteredTotal = 0;
        cart.items.forEach(item => {
          if (item.id !== samplePackVariantId) {
            filteredTotal += item.original_line_price;
          }
        });
        
        const cartValue = filteredTotal / 100;
        
        const shippingBarEl = document.querySelector('.wt-free-shipping-bar');
        if (!shippingBarEl) return;
        
        const threshold = parseFloat(shippingBarEl.dataset.threshold) || 100;
        const remaining = Math.max(0, threshold - cartValue);
        const percentage = Math.min(100, Math.round((cartValue / threshold) * 100));
        
        // Update progress bar
        const progressFill = shippingBarEl.querySelector('.wt-progress-bar__fill');
        if (progressFill) {
          progressFill.style.width = percentage + '%';
        }
        
        // Update text
        const textEl = shippingBarEl.querySelector('.wt-free-shipping-bar__text');
        if (textEl) {
          if (remaining > 0) {
            const remainingFormatted = Shopify.formatMoney(remaining * 100);
            const textTemplate = shippingBarEl.dataset.textTemplate || 'Add ||amount|| more to get free shipping';
            const customText = textTemplate.replace('||amount||', remainingFormatted);
            textEl.textContent = customText;
          } else {
            textEl.textContent = shippingBarEl.dataset.successText || 'You got Free Shipping!';
          }
        }
      })
      .catch(error => console.error('Error updating shipping bar:', error));
  }
  
  // Listen for cart updates
  document.addEventListener('cart:updated', function() {
    setTimeout(updateFreeShippingBar, 300);
  });
  
  // Listen for quantity changes
  document.addEventListener('change', function(e) {
    if (e.target.classList.contains('quantity__input')) {
      setTimeout(updateFreeShippingBar, 500);
    }
  });
  
  // Listen for PUB_SUB_EVENTS if available
  if (typeof PUB_SUB_EVENTS !== 'undefined' && typeof subscribe !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.cartUpdate, function() {
      setTimeout(updateFreeShippingBar, 300);
    });
  }
  
  // Also intercept fetch calls to cart/add
  // const originalFetchForShipping = window.fetch;
  // window.fetch = function() {
  //   const url = arguments[0];
  //   return originalFetchForShipping.apply(this, arguments).then(response => {
  //     if (typeof url === 'string' && (url.includes('/cart/add') || url.includes('/cart/update') || url.includes('/cart/change'))) {
  //       setTimeout(updateFreeShippingBar, 500);
  //     }
  //     return response;
  //   });
  // };
})();
// Listen for any cart additions and update shipping bar
(function() {
  // Store original shipping bar data on page load
  let shippingBarData = null;
  
  function storeShippingBarData() {
    const shippingBar = document.querySelector('.wt-free-shipping-bar');
    if (shippingBar && !shippingBarData) {
      shippingBarData = {
        threshold: shippingBar.dataset.threshold,
        textTemplate: shippingBar.dataset.textTemplate,
        successText: shippingBar.dataset.successText
      };
    }
  }
  
  function restoreShippingBarData() {
    if (!shippingBarData) return;
    
    const shippingBar = document.querySelector('.wt-free-shipping-bar');
    if (shippingBar) {
      shippingBar.dataset.threshold = shippingBarData.threshold;
      shippingBar.dataset.textTemplate = shippingBarData.textTemplate;
      shippingBar.dataset.successText = shippingBarData.successText;
    }
  }
  
  // Store data on load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', storeShippingBarData);
  } else {
    storeShippingBarData();
  }
  
  // Observe changes to milestoneWrapper
  const observer = new MutationObserver(function(mutations) {
    mutations.forEach(function(mutation) {
      if (mutation.type === 'childList') {
        restoreShippingBarData();
        // Trigger update after restoration
        setTimeout(function() {
          const event = new CustomEvent('cart:updated');
          document.dispatchEvent(event);
        }, 100);
      }
    });
  });
  
  const milestoneWrapper = document.getElementById('milestoneWrapper');
  if (milestoneWrapper) {
    observer.observe(milestoneWrapper, {
      childList: true,
      subtree: true
    });
  }
})();

(function() {
  const originalFetch = window.fetch;

  window.fetch = function() {
    const url = arguments[0];

    return originalFetch.apply(this, arguments).then(response => {

      if (typeof url === 'string' &&
          (url.includes('/cart/add') ||
           url.includes('/cart/update') ||
           url.includes('/cart/change'))) {

        setTimeout(() => {

          // Update milestone instantly
          if (window.autoMilestone) {
            window.autoMilestone.updateMilestone();
          }

          // Update free shipping bar
          document.dispatchEvent(new CustomEvent('cart:updated'));

          // Show milestone wrapper
          const wrapper = document.getElementById('milestoneWrapper');
          if (wrapper) wrapper.classList.remove('hidden-milestone');

          const wrapperCartPage = document.getElementById('milestoneWrapper-cartpage');
if (wrapperCartPage) wrapperCartPage.classList.remove('hidden-milestone');

        }, 300);
      }

      return response;
    });
  };
})();